import { defineMessages } from 'react-intl';

export default defineMessages({
  passkeyAuthOrLoginWith: {
    id: 'passkey.auth.or-login-with',
    defaultMessage: 'Or login with:',
  },
});
